import ConfirmacaoCadastro from "@/modules/ConfirmacaoCadastro/pages/ConfirmacaoCadastro";

export default [
  {
    path: "/new-password/:mailtoken",
    component: ConfirmacaoCadastro,
  },
];
